<template>
  <v-container :class="['mx-auto']" style="max-width: 1340px">
    <v-card>
      <v-card-title>Centros de Servicio</v-card-title>
      <v-card-text>
        <iframe
          src="https://www.google.com/maps/d/u/3/embed?mid=1b2l86XAqhLfO2753L9xOPMw_TQ38eOho&ehbc=2E312F"
          width="100%"
          height="600"
        ></iframe>
        <br />
        <small>
          Vista 
          <a 
            href="https://www.google.com/maps/d/u/3/edit?mid=1b2l86XAqhLfO2753L9xOPMw_TQ38eOho&usp=sharing" 
            style="color:#0000FF;text-align:left"
            target="_blank"
          >
            Maquinarias Domosa
          </a>
          Maximizar mapa.
        </small>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "CentroServicio",
  data() {
    return{

    }

  }
}
</script>
